import React, { useState, useEffect } from 'react';
import { Flame, ShoppingBag, Heart, User } from 'lucide-react';
import { authService } from '../../shared/services';

interface MobileHeaderProps {
  cartCount?: number;
  onOpenCart?: () => void;
  onOpenAccount?: (tab?: string) => void;
  onScrollToTop: () => void;
  onTriggerShopTransition?: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = React.memo(({
  cartCount = 0,
  onOpenCart,
  onOpenAccount,
  onScrollToTop,
  onTriggerShopTransition,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => authService.isLoggedIn());
  const [user, setUser] = useState(() => authService.getUser());

  useEffect(() => {
    const unsub = authService.subscribe(() => {
      setIsLoggedIn(authService.isLoggedIn());
      setUser(authService.getUser());
    });
    return () => unsub();
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-40 px-4 sm:px-5 py-3 bg-black/80 backdrop-blur-xl border-b border-white/10 flex items-center justify-between text-[#f5f5f0] pointer-events-auto">
      {/* Brand Logo on Left */}
      <button
        onClick={onScrollToTop}
        className="flex items-center space-x-2 text-left focus:outline-none cursor-pointer"
      >
        <div className="w-8 h-8 rounded-full border border-amber-400/40 bg-amber-950/40 flex items-center justify-center">
          <Flame className="w-4 h-4 text-amber-300" />
        </div>
        <div>
          <span className="font-serif text-base tracking-[0.18em] font-light block leading-none">
            NOOR PIECES
          </span>
          <span className="text-[8px] font-sans tracking-[0.2em] text-[#C8A45A] uppercase block mt-0.5">
            Handcrafted
          </span>
        </div>
      </button>

      {/* Right Navigation Controls: Collection Button ONLY */}
      <div className="flex items-center">
        <button
          onClick={() => {
            if (onTriggerShopTransition) {
              onTriggerShopTransition();
            } else if (onOpenCart) {
              onOpenCart();
            }
          }}
          className="text-xs font-serif uppercase tracking-[0.18em] font-semibold text-[#C8A45A] bg-[#1A1817] px-3 py-1.5 rounded-full border border-[#C8A45A]/40 cursor-pointer hover:bg-[#C8A45A] hover:text-[#1A1817] transition-all active:scale-95 shadow-[0_0_10px_rgba(200,164,90,0.2)]"
        >
          ✨ Collection
        </button>
      </div>
    </header>
  );
});




